import { html } from 'lit';
import type { Purpose } from '@common/types/model.d.js';
import type { TefComs4p } from '@src/components/TefComs4p.js';
import { consentStore } from '@src/store/index.js';

//
// renders the main compoennt view
//
export const tefComs4pView = function render(this: TefComs4p) {
  return html`
    <one-content>
      <one-stack gap="md">
        <one-heading level="h4" variant="default">Partner-APP Einstellungen</one-heading>
        <one-text>
          <one-text as="p">
            Im Folgenden ist es möglich, für jede Partner-APP den Verarbeitungen personenbezogener Daten auf Grundlage gesetzlicher Bestimmungen zu widersprechen und die ggf. erteilten Einwilligungen einzusehen.
          </one-text>
          <one-text as="p">
            Nähere Informationen zu den Partner-Services und Verarbeitungszwecken sind unter Partner-Services Einstellungen zu finden.
          </one-text>
        </one-text>
        <one-stack gap="lg">
          ${consentStore.actualConsents.map((purpose : Purpose) => this.getTemplateFn('singlePurposeView')(purpose))}
        </one-stack>
        ${this.mode !== 'no-back-button' ? html`
        <section class="section section-buttons">
          <div class="form-row">
            <tef-coms-back-button text="Zurück"></tef-coms-back-button>
          </div>
        </section>
        ` : ''}
      </one-stack>
    </one-content>
  `;
};
